import { ZAttribute } from "src/types/ZAttribute";
import { StoreFormulaWithFinancialInputStd } from "./StoreFormulaWithFinancialInputStd";
import { StoreFinancialInput } from ".";

export const createStoreFormulaWithFinancialInput = (
  attr: ZAttribute,
): StoreFinancialInput => new StoreFormulaWithFinancialInputStd(attr);
